import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';

const LeadImageWidget = ({ meta, title, image, containerSettings }) => (
  <Container settings={containerSettings}>
    <div className="lead-image">
      <div className="image-wrapper shift-two-cols">
        <Img src={image} variant="lead" />
      </div>

      <div className="titles-wrapper">
        <div className="shift-two-cols">
          <div className="lead-image-titles">
            {meta === '' ? '' : <h6>{meta}</h6>}
            {title === '' ? '' : <h1 className="lead-image-title">{title}</h1>}
          </div>
        </div>
      </div>

      <div className="lead-image-bg" style={{ backgroundImage: `url(${typeof image === 'string' ? image : image.urls.lead})` }} />
      <div className="overlay" />
    </div>
  </Container>
);

LeadImageWidget.title = 'Lead Image';
LeadImageWidget.preview = 'lead-image.png';
LeadImageWidget.category = 'Layout';

LeadImageWidget.propTypes = {
  meta: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.any.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

LeadImageWidget.defaults = {
  meta: 'Meta information',
  title: 'Article Title',
  image: 'http://placehold.it/769x392',
  containerSettings: {},
};

LeadImageWidget.adminFields = {
  meta: { type: 'text' },
  title: { type: 'text' },
  image: { type: 'image' },
};

export default LeadImageWidget;
